import { ReactNode, useEffect, useState } from 'react';
import { ButtonBase, Image, Text } from '@belong/ui';
import clsx from 'clsx';
import styles from './dropdown.module.css';

type Props = {
  items: ReactNode[];
  defaultSelectedItem?: number;
  onSelectedItemChange: (idx: number) => void;
};

export function Dropdown({
  items,
  defaultSelectedItem = 0,
  onSelectedItemChange,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(defaultSelectedItem);

  const handleDropdownClick = () => {
    setIsOpen(!isOpen);
  };

  const handleDropdownItemClick = (idx: number) => {
    setIsOpen(false);
    setSelectedItem(idx);
    onSelectedItemChange(idx);
  };

  useEffect(() => {
    setSelectedItem(defaultSelectedItem);
  }, [defaultSelectedItem, setSelectedItem]);

  return (
    <div className="relative w-full">
      <ButtonBase
        onClick={handleDropdownClick}
        className={clsx(
          'h-2xl duration-hover flex w-full items-center justify-between border-0 border-b-2 border-solid transition',
          isOpen ? 'border-green' : 'border-gray',
        )}
      >
        <Text>{items[selectedItem]}</Text>
        <div
          className={clsx(styles.DropdownIcon, 'mr-2sm', {
            'rotate-180': isOpen,
          })}
        >
          <Image src="/icons/icon_dropdown.png" alt="" />
        </div>
      </ButtonBase>
      {isOpen && (
        <>
          <div className="fixed inset-0" onClick={() => setIsOpen(false)} />
          <ul className="border-gray absolute top-full z-50 w-full overflow-hidden rounded-b border border-t-0 border-solid bg-white">
            {items.map((item, idx) => (
              <li className="w-full list-none" key={idx}>
                <ButtonBase
                  onClick={() => handleDropdownItemClick(idx)}
                  className="p-xs pt-2sm hover:bg-light-gray flex w-full items-center justify-between"
                >
                  <Text>{item}</Text>
                  {idx === selectedItem && (
                    <div className={styles.DrawingCheckIcon}>
                      <Image src="/icons/icon_green_drawing_check.png" alt="" />
                    </div>
                  )}
                </ButtonBase>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
